// Archived from https://safe-client.safe.global/v1/chains on 2024-02-18

import { type ChainInfo } from '@safe-global/safe-gateway-typescript-sdk'

const SUPPORTED_CHAINS = [
  {
    chainId: '1',
    chainName: 'Ethereum',
    description: 'The main Ethereum network',
    chainLogoUri: null,
    l2: false,
    isTestnet: false,
    nativeCurrency: {
      name: 'Ether',
      symbol: 'ETH',
      decimals: 18,
      logoUri: '/images/chains/1.png',
    },
    transactionService: 'https://safe-transaction-mainnet.safe.global',
    blockExplorerUriTemplate: {
      address: 'https://etherscan.io/address/{{address}}',
      txHash: 'https://etherscan.io/tx/{{txHash}}',
      api: 'https://api.etherscan.io/api?module={{module}}&action={{action}}&address={{address}}&apiKey={{apiKey}}',
    },
    disabledWallets: ['NONE', 'opera', 'operaTouch', 'safeMobile', 'socialSigner', 'tally', 'trust', 'walletConnect'],
    ensRegistryAddress: '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e',
    features: [
      'CONTRACT_INTERACTION',
      'COUNTERFACTUAL',
      'DEFAULT_TOKENLIST',
      'DOMAIN_LOOKUP',
      'EIP1271',
      'EIP1559',
      'ERC721',
      'MOONPAY_MOBILE',
      'NATIVE_WALLETCONNECT',
      'PUSH_NOTIFICATIONS',
      'RECOVERY',
      'RISK_MITIGATION',
      'SAFE_APPS',
      'SAFE_TX_GAS_OPTIONAL',
      'SOCIAL_LOGIN',
      'SPENDING_LIMIT',
      'TX_SIMULATION',
    ],
    gasPrice: [],
    publicRpcUri: {
      authentication: 'NO_AUTHENTICATION',
      value: 'https://cloudflare-eth.com',
    },
    rpcUri: {
      authentication: 'API_KEY_PATH',
      value: 'https://mainnet.infura.io/v3/',
    },
    safeAppsRpcUri: {
      authentication: 'API_KEY_PATH',
      value: 'https://mainnet.infura.io/v3/',
    },
    shortName: 'eth',
    theme: {
      textColor: '#001428',
      backgroundColor: '#DDDDDD',
    },
  },
  {
    chainId: '100',
    chainName: 'Gnosis Chain',
    description: '',
    chainLogoUri: null,
    l2: true,
    isTestnet: false,
    nativeCurrency: {
      name: 'xDai',
      symbol: 'XDAI',
      decimals: 18,
      logoUri: '/images/chains/100.png',
    },
    transactionService: 'https://safe-transaction-gnosis-chain.safe.global',
    blockExplorerUriTemplate: {
      address: 'https://gnosisscan.io/address/{{address}}',
      txHash: 'https://gnosisscan.io/tx/{{txHash}}/',
      api: 'https://api.gnosisscan.io/api?module={{module}}&action={{action}}&address={{address}}&apiKey={{apiKey}}',
    },
    disabledWallets: ['keystone', 'NONE', 'opera', 'operaTouch', 'safeMobile', 'tally', 'trust', 'walletConnect'],
    ensRegistryAddress: null,
    features: [
      'CONTRACT_INTERACTION',
      'COUNTERFACTUAL',
      'DEFAULT_TOKENLIST',
      'EIP1271',
      'EIP1559',
      'ERC721',
      'NATIVE_WALLETCONNECT',
      'PUSH_NOTIFICATIONS',
      'RECOVERY',
      'RELAYING',
      'RELAYING_MOBILE',
      'RISK_MITIGATION',
      'SAFE_APPS',
      'SAFE_TX_GAS_OPTIONAL',
      'SOCIAL_LOGIN',
      'SPENDING_LIMIT',
      'TX_SIMULATION',
      'WEB3AUTH_CREATE_SAFE',
    ],
    gasPrice: [
      {
        type: 'fixed',
        weiValue: '4000000000',
      },
    ],
    publicRpcUri: {
      authentication: 'NO_AUTHENTICATION',
      value: 'https://rpc.gnosis.gateway.fm',
    },
    rpcUri: {
      authentication: 'NO_AUTHENTICATION',
      value: 'https://rpc.gnosis.gateway.fm',
    },
    safeAppsRpcUri: {
      authentication: 'NO_AUTHENTICATION',
      value: 'https://rpc.gnosis.gateway.fm',
    },
    shortName: 'gno',
    theme: {
      textColor: '#ffffff',
      backgroundColor: '#48A9A6',
    },
  },
  {
    chainId: '137',
    chainName: 'Polygon',
    description: 'L2 chain (MATIC)',
    chainLogoUri: null,
    l2: true,
    isTestnet: false,
    nativeCurrency: {
      name: 'Matic',
      symbol: 'MATIC',
      decimals: 18,
      logoUri: '/images/chains/137.png',
    },
    transactionService: 'https://safe-transaction-polygon.safe.global',
    blockExplorerUriTemplate: {
      address: 'https://polygonscan.com/address/{{address}}',
      txHash: 'https://polygonscan.com/tx/{{txHash}}',
      api: 'https://api.polygonscan.com/api?module={{module}}&action={{action}}&address={{address}}&apiKey={{apiKey}}',
    },
    disabledWallets: [
      'keystone',
      'NONE',
      'opera',
      'operaTouch',
      'safeMobile',
      'socialSigner',
      'tally',
      'trezor',
      'trust',
      'walletConnect',
    ],
    ensRegistryAddress: null,
    features: [
      'CONTRACT_INTERACTION',
      'COUNTERFACTUAL',
      'DEFAULT_TOKENLIST',
      'EIP1271',
      'EIP1559',
      'ERC721',
      'MOONPAY_MOBILE',
      'NATIVE_WALLETCONNECT',
      'PUSH_NOTIFICATIONS',
      'RECOVERY',
      'RISK_MITIGATION',
      'SAFE_APPS',
      'SAFE_TX_GAS_OPTIONAL',
      'SOCIAL_LOGIN',
      'SPENDING_LIMIT',
      'TX_SIMULATION',
    ],
    gasPrice: [],
    publicRpcUri: {
      authentication: 'NO_AUTHENTICATION',
      value: 'https://polygon-rpc.com',
    },
    rpcUri: {
      authentication: 'API_KEY_PATH',
      value: 'https://polygon-mainnet.infura.io/v3/',
    },
    safeAppsRpcUri: {
      authentication: 'API_KEY_PATH',
      value: 'https://polygon-mainnet.infura.io/v3/',
    },
    shortName: 'matic',
    theme: {
      textColor: '#ffffff',
      backgroundColor: '#8248E5',
    },
  },
  {
    chainId: '1101',
    chainName: 'Polygon zkEVM',
    description: 'Polygon zkEVM',
    chainLogoUri: null,
    l2: true,
    isTestnet: false,
    nativeCurrency: {
      name: 'Ether',
      symbol: 'ETH',
      decimals: 18,
      logoUri: '/images/chains/1101.png',
    },
    transactionService: 'https://safe-transaction-zkevm.safe.global/',
    blockExplorerUriTemplate: {
      address: 'https://zkevm.polygonscan.com/address/{{address}}',
      txHash: 'https://zkevm.polygonscan.com/tx/{{txHash}}',
      api: 'https://api-zkevm.polygonscan.com/api?module={{module}}&action={{action}}&address={{address}}&apiKey={{apiKey}}',
    },
    disabledWallets: [
      'coinbase',
      'keystone',
      'NONE',
      'opera',
      'operaTouch',
      'safeMobile',
      'socialSigner',
      'tally',
      'trust',
      'walletConnect',
    ],
    ensRegistryAddress: null,
    features: [
      'CONTRACT_INTERACTION',
      'COUNTERFACTUAL',
      'ERC721',
      'NATIVE_WALLETCONNECT',
      'PUSH_NOTIFICATIONS',
      'SAFE_APPS',
      'SOCIAL_LOGIN',
      'SPENDING_LIMIT',
    ],
    gasPrice: [],
    publicRpcUri: {
      authentication: 'NO_AUTHENTICATION',
      value: 'https://zkevm-rpc.com',
    },
    rpcUri: {
      authentication: 'NO_AUTHENTICATION',
      value: 'https://zkevm-rpc.com',
    },
    safeAppsRpcUri: {
      authentication: 'NO_AUTHENTICATION',
      value: 'https://zkevm-rpc.com',
    },
    shortName: 'zkevm',
    theme: {
      textColor: '#000000',
      backgroundColor: '#F5F0FD',
    },
  },
  {
    chainId: '56',
    chainName: 'BNB Chain',
    description: '',
    chainLogoUri: null,
    l2: true,
    isTestnet: false,
    nativeCurrency: {
      name: 'BNB',
      symbol: 'BNB',
      decimals: 18,
      logoUri: '/images/chains/56.png',
    },
    transactionService: 'https://safe-transaction-bsc.safe.global',
    blockExplorerUriTemplate: {
      address: 'https://bscscan.com/address/{{address}}',
      txHash: 'https://bscscan.com/tx/{{txHash}}',
      api: 'https://api.bscscan.com/api?module={{module}}&action={{action}}&address={{address}}&apiKey={{apiKey}}',
    },
    disabledWallets: [
      'keystone',
      'NONE',
      'opera',
      'operaTouch',
      'safeMobile',
      'socialSigner',
      'tally',
      'trust',
      'walletConnect',
    ],
    ensRegistryAddress: null,
    features: [
      'CONTRACT_INTERACTION',
      'COUNTERFACTUAL',
      'DEFAULT_TOKENLIST',
      'EIP1271',
      'ERC721',
      'MOONPAY_MOBILE',
      'NATIVE_WALLETCONNECT',
      'PUSH_NOTIFICATIONS',
      'RISK_MITIGATION',
      'SAFE_APPS',
      'SAFE_TX_GAS_OPTIONAL',
      'SOCIAL_LOGIN',
      'SPENDING_LIMIT',
      'TX_SIMULATION',
    ],
    gasPrice: [],
    publicRpcUri: {
      authentication: 'NO_AUTHENTICATION',
      value: 'https://bsc-dataseed.binance.org/',
    },
    rpcUri: {
      authentication: 'NO_AUTHENTICATION',
      value: 'https://bsc-dataseed.binance.org/',
    },
    safeAppsRpcUri: {
      authentication: 'NO_AUTHENTICATION',
      value: 'https://bsc-dataseed.binance.org/',
    },
    shortName: 'bnb',
    theme: {
      textColor: '#001428',
      backgroundColor: '#F0B90B',
    },
  },
  {
    chainId: '42161',
    chainName: 'Arbitrum',
    description: '',
    chainLogoUri: null,
    l2: true,
    isTestnet: false,
    nativeCurrency: {
      name: 'AETH',
      symbol: 'AETH',
      decimals: 18,
      logoUri: '/images/chains/42161.png',
    },
    transactionService: 'https://safe-transaction-arbitrum.safe.global',
    blockExplorerUriTemplate: {
      address: 'https://arbiscan.io/address/{{address}}',
      txHash: 'https://arbiscan.io/tx/{{txHash}}',
      api: 'https://api.arbiscan.io/api?module={{module}}&action={{action}}&address={{address}}&apiKey={{apiKey}}',
    },
    disabledWallets: [
      'keystone',
      'NONE',
      'opera',
      'operaTouch',
      'safeMobile',
      'socialSigner',
      'tally',
      'trust',
      'walletConnect',
    ],
    ensRegistryAddress: null,
    features: [
      'CONTRACT_INTERACTION',
      'COUNTERFACTUAL',
      'EIP1271',
      'ERC721',
      'MOONPAY_MOBILE',
      'NATIVE_WALLETCONNECT',
      'PUSH_NOTIFICATIONS',
      'RECOVERY',
      'RISK_MITIGATION',
      'SAFE_APPS',
      'SAFE_TX_GAS_OPTIONAL',
      'SOCIAL_LOGIN',
      'TX_SIMULATION',
    ],
    gasPrice: [],
    publicRpcUri: {
      authentication: 'NO_AUTHENTICATION',
      value: 'https://arb1.arbitrum.io/rpc',
    },
    rpcUri: {
      authentication: 'NO_AUTHENTICATION',
      value: 'https://arb1.arbitrum.io/rpc',
    },
    safeAppsRpcUri: {
      authentication: 'NO_AUTHENTICATION',
      value: 'https://arb1.arbitrum.io/rpc',
    },
    shortName: 'arb1',
    theme: {
      textColor: '#ffffff',
      backgroundColor: '#28A0F0',
    },
  },
  {
    chainId: '10',
    chainName: 'Optimism',
    description: '',
    chainLogoUri: null,
    l2: true,
    isTestnet: false,
    nativeCurrency: {
      name: 'Ether',
      symbol: 'OETH',
      decimals: 18,
      logoUri: '/images/chains/10.png',
    },
    transactionService: 'https://safe-transaction-optimism.safe.global',
    blockExplorerUriTemplate: {
      address: 'https://optimistic.etherscan.io/address/{{address}}',
      txHash: 'https://optimistic.etherscan.io/tx/{{txHash}}',
      api: 'https://api-optimistic.etherscan.io/api?module={{module}}&action={{action}}&address={{address}}&apiKey={{apiKey}}',
    },
    disabledWallets: [
      'keystone',
      'NONE',
      'opera',
      'operaTouch',
      'safeMobile',
      'socialSigner',
      'tally',
      'trust',
      'walletConnect',
    ],
    ensRegistryAddress: null,
    features: [
      'CONTRACT_INTERACTION',
      'COUNTERFACTUAL',
      'DEFAULT_TOKENLIST',
      'EIP1271',
      'EIP1559',
      'ERC721',
      'MOONPAY_MOBILE',
      'NATIVE_WALLETCONNECT',
      'PUSH_NOTIFICATIONS',
      'RECOVERY',
      'SAFE_APPS',
      'SAFE_TX_GAS_OPTIONAL',
      'SOCIAL_LOGIN',
      'TX_SIMULATION',
    ],
    gasPrice: [
      {
        type: 'fixed1559',
        maxFeePerGas: '100000000',
        maxPriorityFeePerGas: '100000',
      },
    ],
    publicRpcUri: {
      authentication: 'NO_AUTHENTICATION',
      value: 'https://mainnet.optimism.io/',
    },
    rpcUri: {
      authentication: 'API_KEY_PATH',
      value: 'https://optimism-mainnet.infura.io/v3/',
    },
    safeAppsRpcUri: {
      authentication: 'API_KEY_PATH',
      value: 'https://optimism-mainnet.infura.io/v3/',
    },
    shortName: 'oeth',
    theme: {
      textColor: '#ffffff',
      backgroundColor: '#F01A37',
    },
  },
  {
    chainId: '8453',
    chainName: 'Base',
    description: '',
    chainLogoUri: null,
    l2: true,
    isTestnet: false,
    nativeCurrency: {
      name: 'Ether',
      symbol: 'ETH',
      decimals: 18,
      logoUri: '/images/chains/8453.png',
    },
    transactionService: 'https://safe-transaction-base.safe.global',
    blockExplorerUriTemplate: {
      address: 'https://basescan.org/address/{{address}}',
      txHash: 'https://basescan.org/tx/{{txHash}}',
      api: 'https://basescan.org/api?module={{module}}&action={{action}}&address={{address}}&apiKey={{apiKey}}',
    },
    disabledWallets: [
      'coinbase',
      'keystone',
      'NONE',
      'opera',
      'operaTouch',
      'safeMobile',
      'socialSigner',
      'tally',
      'trust',
      'walletConnect',
    ],
    ensRegistryAddress: null,
    features: [
      'CONTRACT_INTERACTION',
      'COUNTERFACTUAL',
      'EIP1271',
      'EIP1559',
      'ERC721',
      'NATIVE_WALLETCONNECT',
      'PUSH_NOTIFICATIONS',
      'SAFE_APPS',
      'SAFE_TX_GAS_OPTIONAL',
      'SOCIAL_LOGIN',
    ],
    gasPrice: [
      {
        type: 'fixed1559',
        maxFeePerGas: '150000000',
        maxPriorityFeePerGas: '100000',
      },
    ],
    publicRpcUri: {
      authentication: 'NO_AUTHENTICATION',
      value: 'https://developer-access-mainnet.base.org',
    },
    rpcUri: {
      authentication: 'API_KEY_PATH',
      value: 'https://base-mainnet.infura.io/v3/',
    },
    safeAppsRpcUri: {
      authentication: 'API_KEY_PATH',
      value: 'https://base-mainnet.infura.io/v3/',
    },
    shortName: 'base',
    theme: {
      textColor: '#ffffff',
      backgroundColor: '#0052FF',
    },
  },
  {
    chainId: '324',
    chainName: 'zkSync Era',
    description: '',
    chainLogoUri: null,
    l2: true,
    isTestnet: false,
    nativeCurrency: {
      name: 'Ether',
      symbol: 'ETH',
      decimals: 18,
      logoUri: '/images/chains/324.png',
    },
    transactionService: 'https://safe-transaction-zksync.safe.global/',
    blockExplorerUriTemplate: {
      address: 'https://explorer.zksync.io/address/{{address}}',
      txHash: 'https://explorer.zksync.io/tx/{{txHash}}',
      api: 'https://api.explorer.zksync.io/api?module={{module}}&action={{action}}&address={{address}}&apiKey={{apiKey}}',
    },
    disabledWallets: [
      'coinbase',
      'keystone',
      'NONE',
      'opera',
      'operaTouch',
      'safeMobile',
      'socialSigner',
      'tally',
      'trust',
      'walletConnect',
    ],
    ensRegistryAddress: null,
    features: ['COUNTERFACTUAL', 'NATIVE_WALLETCONNECT', 'PUSH_NOTIFICATIONS', 'SAFE_APPS', 'SOCIAL_LOGIN'],
    gasPrice: [],
    publicRpcUri: {
      authentication: 'NO_AUTHENTICATION',
      value: 'https://mainnet.era.zksync.io',
    },
    rpcUri: {
      authentication: 'NO_AUTHENTICATION',
      value: 'https://mainnet.era.zksync.io',
    },
    safeAppsRpcUri: {
      authentication: 'NO_AUTHENTICATION',
      value: 'https://mainnet.era.zksync.io',
    },
    shortName: 'zksync',
    theme: {
      textColor: '#ffffff',
      backgroundColor: '#000000',
    },
  },
  {
    chainId: '42220',
    chainName: 'Celo',
    description: '',
    chainLogoUri: null,
    l2: false,
    isTestnet: false,
    nativeCurrency: {
      name: 'CELO',
      symbol: 'CELO',
      decimals: 18,
      logoUri: '/images/chains/42220.png',
    },
    transactionService: 'https://safe-transaction-celo.safe.global',
    blockExplorerUriTemplate: {
      address: 'https://explorer.celo.org/mainnet/address/{{address}}',
      txHash: 'https://explorer.celo.org/mainnet/tx/{{txHash}}',
      api: 'https://explorer.celo.org/mainnet/api?module={{module}}&action={{action}}&address={{address}}&apiKey={{apiKey}}',
    },
    disabledWallets: [
      'coinbase',
      'NONE',
      'opera',
      'operaTouch',
      'safeMobile',
      'socialSigner',
      'tally',
      'trust',
      'walletConnect',
    ],
    ensRegistryAddress: null,
    features: [
      'COUNTERFACTUAL',
      'EIP1271',
      'EIP1559',
      'ERC721',
      'MOONPAY_MOBILE',
      'NATIVE_WALLETCONNECT',
      'PUSH_NOTIFICATIONS',
      'SAFE_APPS',
      'SOCIAL_LOGIN',
      'SPENDING_LIMIT',
    ],
    gasPrice: [],
    publicRpcUri: {
      authentication: 'NO_AUTHENTICATION',
      value: 'https://rpc.ankr.com/celo',
    },
    rpcUri: {
      authentication: 'NO_AUTHENTICATION',
      value: 'https://rpc.ankr.com/celo',
    },
    safeAppsRpcUri: {
      authentication: 'NO_AUTHENTICATION',
      value: 'https://rpc.ankr.com/celo',
    },
    shortName: 'celo',
    theme: {
      textColor: '#000000',
      backgroundColor: '#FCFF52',
    },
  },
  {
    chainId: '43114',
    chainName: 'Avalanche',
    description: '',
    chainLogoUri: null,
    l2: true,
    isTestnet: false,
    nativeCurrency: {
      name: 'Avalanche',
      symbol: 'AVAX',
      decimals: 18,
      logoUri: '/images/chains/43114.png',
    },
    transactionService: 'https://safe-transaction-avalanche.safe.global',
    blockExplorerUriTemplate: {
      address: 'https://snowtrace.io/address/{{address}}',
      txHash: 'https://snowtrace.io/tx/{{txHash}}',
      api: 'https://api.snowtrace.io/api?module={{module}}&action={{action}}&address={{address}}&apiKey={{apiKey}}',
    },
    disabledWallets: [
      'keystone',
      'NONE',
      'opera',
      'operaTouch',
      'safeMobile',
      'socialSigner',
      'tally',
      'trust',
      'walletConnect',
    ],
    ensRegistryAddress: null,
    features: [
      'CONTRACT_INTERACTION',
      'COUNTERFACTUAL',
      'EIP1271',
      'EIP1559',
      'ERC721',
      'MOONPAY_MOBILE',
      'NATIVE_WALLETCONNECT',
      'PUSH_NOTIFICATIONS',
      'RISK_MITIGATION',
      'SAFE_APPS',
      'SAFE_TX_GAS_OPTIONAL',
      'SOCIAL_LOGIN',
      'SPENDING_LIMIT',
      'TX_SIMULATION',
    ],
    gasPrice: [],
    publicRpcUri: {
      authentication: 'NO_AUTHENTICATION',
      value: 'https://api.avax.network/ext/bc/C/rpc',
    },
    rpcUri: {
      authentication: 'NO_AUTHENTICATION',
      value: 'https://api.avax.network/ext/bc/C/rpc',
    },
    safeAppsRpcUri: {
      authentication: 'NO_AUTHENTICATION',
      value: 'https://api.avax.network/ext/bc/C/rpc',
    },
    shortName: 'avax',
    theme: {
      textColor: '#ffffff',
      backgroundColor: '#000000',
    },
  },
  {
    chainId: '1313161554',
    chainName: 'Aurora',
    description: '',
    chainLogoUri: null,
    l2: true,
    isTestnet: false,
    nativeCurrency: {
      name: 'Ether',
      symbol: 'ETH',
      decimals: 18,
      logoUri: '/images/chains/1313161554.png',
    },
    transactionService: 'https://safe-transaction-aurora.safe.global',
    blockExplorerUriTemplate: {
      address: 'https://aurorascan.dev/address/{{address}}/transactions',
      txHash: 'https://aurorascan.dev/tx/{{txHash}}/',
      api: 'https://aurorascan.dev/api?module={{module}}&action={{action}}&address={{address}}&apiKey={{apiKey}}',
    },
    disabledWallets: [
      'coinbase',
      'keystone',
      'NONE',
      'opera',
      'operaTouch',
      'safeMobile',
      'socialSigner',
      'tally',
      'trezor',
      'trust',
      'walletConnect',
    ],
    ensRegistryAddress: null,
    features: [
      'CONTRACT_INTERACTION',
      'COUNTERFACTUAL',
      'DEFAULT_TOKENLIST',
      'EIP1271',
      'ERC721',
      'NATIVE_WALLETCONNECT',
      'PUSH_NOTIFICATIONS',
      'SAFE_APPS',
      'SAFE_TX_GAS_OPTIONAL',
      'SOCIAL_LOGIN',
    ],
    gasPrice: [],
    publicRpcUri: {
      authentication: 'NO_AUTHENTICATION',
      value: 'https://mainnet.aurora.dev',
    },
    rpcUri: {
      authentication: 'NO_AUTHENTICATION',
      value: 'https://mainnet.aurora.dev',
    },
    safeAppsRpcUri: {
      authentication: 'NO_AUTHENTICATION',
      value: 'https://mainnet.aurora.dev',
    },
    shortName: 'aurora',
    theme: {
      textColor: '#ffffff',
      backgroundColor: '#78D64B',
    },
  },
  {
    chainId: '11155111',
    chainName: 'Sepolia',
    description: 'Ethereum Testnet Sepolia',
    chainLogoUri: null,
    l2: true,
    isTestnet: true,
    nativeCurrency: {
      name: 'Sepolia Ether',
      symbol: 'ETH',
      decimals: 18,
      logoUri: '/images/chains/11155111.png',
    },
    transactionService: 'https://safe-transaction-sepolia.safe.global',
    blockExplorerUriTemplate: {
      address: 'https://sepolia.etherscan.io/address/{{address}}',
      txHash: 'https://sepolia.etherscan.io/tx/{{txHash}}',
      api: 'https://api-sepolia.etherscan.io/api?module={{module}}&action={{action}}&address={{address}}&apiKey={{apiKey}}',
    },
    disabledWallets: [
      'coinbase',
      'NONE',
      'opera',
      'operaTouch',
      'safeMobile',
      'socialSigner',
      'tally',
      'trust',
      'walletConnect',
    ],
    ensRegistryAddress: '0x8FADE66B79cC9f707aB26799354482EB93a5B7dD',
    features: [
      'CONTRACT_INTERACTION',
      'COUNTERFACTUAL',
      'DEFAULT_TOKENLIST',
      'DOMAIN_LOOKUP',
      'EIP1271',
      'EIP1559',
      'ERC721',
      'NATIVE_WALLETCONNECT',
      'PUSH_NOTIFICATIONS',
      'RECOVERY',
      'RELAYING',
      'SAFE_APPS',
      'SAFE_TX_GAS_OPTIONAL',
      'SOCIAL_LOGIN',
      'SPENDING_LIMIT',
      'TX_SIMULATION',
    ],
    gasPrice: [],
    publicRpcUri: {
      authentication: 'NO_AUTHENTICATION',
      value: 'https://rpc.sepolia.org',
    },
    rpcUri: {
      authentication: 'API_KEY_PATH',
      value: 'https://sepolia.infura.io/v3/',
    },
    safeAppsRpcUri: {
      authentication: 'API_KEY_PATH',
      value: 'https://sepolia.infura.io/v3/',
    },
    shortName: 'sep',
    theme: {
      textColor: '#ffffff',
      backgroundColor: '#B8AAD5',
    },
  },
]

export const getChainsConfig = (): ChainInfo[] => {
  return SUPPORTED_CHAINS as ChainInfo[]
}

export default getChainsConfig
